import { h } from "preact";

import { classNames } from "../helpers";
import tracking from "../tracking/tracking";
import Icon from "./Icon.jsx";

export default function FilterPill({
  children,
  count,
  selected,
  open,
  trackingParams,
  ...props
}) {
  const classes = [
    "waves-effect",
    "waves-light",
    "filter-pill",
    "z-depth-0",
    props.class,
  ];

  if (selected || count) {
    classes.push("filter-pill--selected");
  }
  if (open) {
    classes.push("filter-pill--open");
  }

  function handleClick(event) {
    if (props.onClick) {
      props.onClick(event);
    }

    tracking.track("filterPill.click", {
      name: children,
      ...(trackingParams || {}),
    });
  }

  return (
    <span {...props} onClick={handleClick} class={classNames(...classes)}>
      <span class="filter-pill__text">{children}</span>
      {count && <span class="filter-pill__count">{count}</span>}
      <Icon class="filter-pill__icon">expand_more</Icon>
    </span>
  );
}
